/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Price_item$ref = any;
type Shipping_item$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type Info_item$ref = any;
export type Info_item = {
    readonly classification: {
        readonly creationDate: string | null;
    } | null;
    readonly creators: ReadonlyArray<{
        readonly attribution: string | null;
        readonly creator: {
            readonly displayName: string | null;
        } | null;
    } | null> | null;
    readonly localizedPdpUrl: string | null;
    readonly title: string | null;
    readonly vertical: VerticalType | null;
    readonly " $fragmentRefs": Price_item$ref & Shipping_item$ref;
    readonly " $refType": Info_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "Info_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean",
            "defaultValue": false
        },
        {
            "kind": "LocalArgument",
            "name": "pageDisplayEnum",
            "type": "PageDisplayEnum",
            "defaultValue": "searchAndBrowse"
        },
        {
            "kind": "LocalArgument",
            "name": "showPrice",
            "type": "Boolean",
            "defaultValue": true
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "classification",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemClassification",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "creationDate",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "creators",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemCreator",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "attribution",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Creator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayName",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "localizedPdpUrl",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "vertical",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "Price_item",
            "args": [
                {
                    "kind": "Variable",
                    "name": "isTrade",
                    "variableName": "isTrade"
                },
                {
                    "kind": "Variable",
                    "name": "pageDisplayEnum",
                    "variableName": "pageDisplayEnum"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "Shipping_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '4508c9148cbf26bec3e28ba6042a1b74';
export default node;
